import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary'

import { ScannerPageContent } from './ScannerPageContent'

export const ScannerPage = withDefaultErrorBoundary(ScannerPageContent)
